export default __webpack_public_path__ + "static/media/staking-illustration.0c41e4ef.svg";